export default "__VITE_ASSET__4c8e606d__"